import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=1808b7e8"
import script from "./RefundPolicy.vue?vue&type=script&lang=ts"
export * from "./RefundPolicy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports